


















































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import dayjs from 'dayjs';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InfiniteLoading from '@/components/InfiniteLoading.vue';
import CheckBox from '@/components/CheckBoxC.vue';
import { queryLogList } from '@/api/alarm';
import Input from '@/components/TextInput.vue';

@Component({
  components: {
    'infinite-loading': InfiniteLoading,
    'rap-checkbox': CheckBox,
    'rap-textinput': Input,
  },
})
export default class HelloWorld extends Vue {
  @Prop() private handleStatus!: number | string;
  @Prop() private isAllSelected?: boolean;
  private searchKey = '';

  private current = 1;
  private pageSize = 10;
  private isHasMore = true;
  private isLoading = false;
  private taskId: string | any[] = this.$route.query.taskId;
  private list: any[] = [];
  private itemSelected = false;

  private created(): void {
    this.initData();
  }
  private getSelectedListParams(list: any[]): any[] {
    const paramsList = list
      .filter((record: any) => record.selected)
      .map((record: any) => {
        return {
          ...record,
          handleWay: '',
          pauseType: '',
          id: record.id,
          taskId: record.taskId,
          isOwner: record.isOwner,
          isCreated: record.isCreated,
          isHandled: record.isHandled,
          isTransfer: record.isTransfer,
          handleStatus: record.handleStatus,
          isGroupBy: record.isGroupBy,
          triggerTime: record.triggerTime,
          taskName: record.taskName,
        };
      });
    return paramsList;
  }
  private async initData(): Promise<void> {
    this.isLoading = true;
    const listResult: any = await queryLogList({
      handleStatus: this.handleStatus,
      current: this.current,
      pageSize: this.pageSize,
      begin: dayjs().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
      end: dayjs().format('YYYY-MM-DD') + ' 23:59:59',
      ...(this.searchKey
        ? {
            [`${isNaN(Number(this.searchKey)) ? 'value' : 'alarmId'}`]:
              this.searchKey,
          }
        : {}),
    });
    this.isLoading = false;
    if (listResult.code === 0) {
      let newList = listResult.data.list;
      newList = newList.map((item: any) => {
        return {
          ...item,
          selected:
            this.isAllSelected === true
              ? true
              : item.selected === true || item.selected === false
              ? item.selected
              : false,
        };
      });
      const list = this.current === 1 ? newList : [...this.list, ...newList];
      this.list = list;
      this.$emit('list-change', this.getSelectedListParams(list));

      this.current = this.current + 1;
      if (listResult.data.list.length < this.pageSize) {
        this.isHasMore = false;
      } else {
        this.isHasMore = true;
      }
    }
  }

  private submitSearch(): void {
    window.scrollTo(0, 0);
    this.current = 1;

    this.initData();
  }

  private goDetail(item: any): void {
    this.$router.push({
      path: '/alarmdetail',
      query: {
        id: item.id,
      },
    });
  }
  private onInfinite(): void {
    this.initData();
  }
  private chooseItem(checked: boolean, item: any): void {
    let newChecked = checked;

    const list = this.list;
    const index = list.findIndex((record) => record.id === item.id);
    if (typeof checked !== 'boolean') {
      newChecked = !list[index].selected;
    }
    list[index].selected = newChecked;
    this.$set(this.list, index, item);
    this.$emit('list-change', this.getSelectedListParams(list));
  }
  @Watch('isAllSelected')
  private getAllSelected(newVal: boolean) {
    const list = this.list.map((record) => {
      return {
        ...record,
        selected: newVal,
      };
    });

    list.map((item, index) => {
      this.$set(this.list, index, item);
    });
    this.$emit('list-change', this.getSelectedListParams(list));
  }
}
